<template>
  <div>
    <h3 class="d-flex justify-start py-5">{{ $t('artwork_type.title_plural') }}</h3>
    <v-data-table
      :loading="loading"
      :items="artworkTypesList"
      :headers="headers"
      :no-data-text="$t('table_settings.no_data')"
      :loading-text="$t('table_settings.loading_data')"
      :header-props="{
        sortByText: $t('table_settings.sort_by')
      }"
      :footer-props="{
        itemsPerPageAllText: $t('table_settings.all'),
        itemsPerPageOptions: [10, 25, 50, -1],
        itemsPerPageText: $t('table_settings.items_per_page')
        }">
      <template v-slot:[`item.edit`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="editItem(item)">
          mdi-pencil-outline
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)">
          mdi-delete-outline
        </v-icon>
      </template>
    </v-data-table>
    <artwork-type-edit :initArtworkType="editedItem"
        :show-dialog="this.showDialog"
        @onSave="onSaveSuccess"
        @onCancel="onSaveCancel">
    </artwork-type-edit>
    <div class="mx-10">
      <v-col class="text-right">
        <v-btn fab small color="primary" @click="addItem" absolute>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </div>
    <v-snackbar v-model="showDeleteErrorSnackbar" color="error">
      {{ $t('common_error.could_not_delete_item') }}
    </v-snackbar>
    <v-snackbar v-model="showLoadingErrorSnackbar" color="error">
      {{ $t('common_error.could_not_load_items')}}
    </v-snackbar>
    <confirm-dialog :show-dialog="this.showConfirmDeleteDialog"
      confirm-color="error"
      :question-text="this.confirmDeleteDialogText"
      :positive-text="$t('common_actions.delete')"
      :negative-text="$t('common_actions.cancel')"
      @onCancel="cancelDeleteItem"
      @onConfirm="confirmDeleteItem">
    </confirm-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ArtworkTypeEdit from '@/components/codebooks/editors/ArtworkTypeEdit'
import ConfirmDialog from '@/components/common/ConfirmDialog'

export default {
  components: { ArtworkTypeEdit, ConfirmDialog },
  name: 'ArtworkTypes',
  data: () => ({
    loading: false,
    showConfirmDeleteDialog: false,
    confirmDeleteDialogText: '',
    showDialog: false,
    showDeleteErrorSnackbar: false,
    showLoadingErrorSnackbar: false,
    editedItem: {
      id: 0,
      index: -1,
      name: '',
      code: ''
    },
    headers: [
      {
        text: i18n.t('artwork_type.name'),
        value: 'name',
        align: 'start',
        sortable: true
      },
      {
        text: i18n.t('artwork_type.code'),
        align: 'start',
        value: 'code',
        sortable: true
      },
      {
        text: i18n.t('table_settings.edit'),
        align: 'end',
        value: 'edit',
        sortable: false
      }
    ]
  }),
  computed: {
    artworkTypesList () {
      return this.$store.state.artworkTypes.artworkTypesList
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('artworkTypes/refreshArtworkTypes').then(result => {
      this.loading = false
    }, _ => {
      this.loading = false
      this.showLoadingErrorSnackbar = true
    })
  },
  methods: {
    cancelDeleteItem () {
      this.showConfirmDeleteDialog = false
    },
    confirmDeleteItem () {
      this.showConfirmDeleteDialog = false
      this.loading = true
      this.$store.dispatch('artworkTypes/deleteArtworkType', this.editedItem).then(result => {
        this.loading = false
      }, _ => {
        this.loading = false
        this.showDeleteErrorSnackbar = true
      })
    },
    editItem (item) {
      this.editedItem.id = item.id
      this.editedItem.name = item.name
      this.editedItem.code = item.code
      this.editedItem.index = this.artworkTypesList.indexOf(item)
      this.showDialog = true
    },
    deleteItem (item) {
      if (this.loading) {
        return
      }
      this.editedItem.id = item.id
      this.editedItem.name = item.name
      this.editedItem.index = this.artworkTypesList.indexOf(item)
      this.confirmDeleteDialogText = i18n.t('common_actions.confirm_delete') + ' Položka: ' + this.editedItem.name
      this.showConfirmDeleteDialog = true
    },
    addItem () {
      this.editedItem.id = 0
      this.editedItem.index = -1
      this.editedItem.name = ''
      this.editedItem.code = ''
      this.showDialog = true
    },
    onSaveSuccess () {
      this.showDialog = false
    },
    onSaveCancel () {
      this.showDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/codebooks/ArtworkTypes.vue